import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Don't scroll to top for routes handled by AnimatedLayout
    // These routes manage their own smooth transitions
    const isAnimatedRoute = 
      pathname.startsWith('/starters') || 
      pathname.startsWith('/saved');
    
    if (!isAnimatedRoute) {
      // Scroll to top when pathname changes for non-animated routes
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null; // This component doesn't render anything
};

export default ScrollToTop; 